// utils/formatters.js
export const formatIndianCurrency = (amount) => {
  if (!amount && amount !== 0) return '₹0';
  
  const formatted = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
  
  return formatted;
};

export const formatDate = (dateString, format = 'DD MMM YYYY') => {
  if (!dateString) return 'N/A';
  
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, '0');
  const month = date.toLocaleString('default', { month: 'short' });
  const year = date.getFullYear();
  
  return format
    .replace('DD', day)
    .replace('MMM', month)
    .replace('YYYY', year);
};